var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 30.2c.6.4 1.6.2 2.2-.2l7.2-5.8 7.2 5.8c.8.6 2.2.6 2.8-.4.2-.4.4-.8.4-1.2v-23c0-2.2-1.8-3.8-3.8-3.8H9.4c-2.2 0-3.8 1.8-3.8 3.8v23c-.2.8.4 1.4 1 1.8m16-24.8v18.8L17.2 20c-.8-.6-1.8-.6-2.4 0l-5.2 4.2-.2-18.6z"
  })));
};
export default SvgBookmark;